import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import "./App.css";
import LandingFooter from "./Footer";
import "./style/reset.css";

const dev = false; // false 로 바꾸고 prod 빌드 하기
const base = dev ? "" : "/loss-reward";

function App() {
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  console.log(`m: ${isMobile}`);

  const source = new URLSearchParams(window.location.search).get(
    "source"
  );

  console.log(`s: ${source}`);

  // 토스트 띄우기
  const notify = () => toast("링크가 복사됐어요");

  const SHARE_URL = "https://invite.domino.is/loss-reward?source=share";
  const deeplink = source === "share"
      ? `https://dominoapp.onelink.me/vY2c/e1674xtu` // 앱에서 오는 경우 (복사/공유)
      : `https://dominoapp.onelink.me/vY2c/hcmv7qsg` // 광고로 오는 경우
      // https://dominoapp.onelink.me/vY2c/sfjsxvci // 데스크탑 용 (QR 코드로 공유 됨)

  const copyTextToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Text copied to clipboard:", text);
        notify();
        // 복사가 성공했을 때의 처리를 추가할 수 있습니다.
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
        // 복사 실패 시의 처리를 추가할 수 있습니다.
      });
  };

  const handleCopyToClipboard = () => {
    copyTextToClipboard(SHARE_URL);
  };

  const webShareUrl = async () => {
    const url: string = SHARE_URL;
    const shareData = {
      title: "도미노 - 모든 투자를 트래킹하세요",
      text: "주식 손실지원금 받아가세요!",
      url,
    };

    try {
      if (!navigator.canShare(shareData)) {
        throw new Error("데이터를 공유할 수 없습니다.");
      }
      await navigator.share(shareData);
    } catch (err) {
      console.error(err);
    }
  };

  if (isMobile) {
    return (
      <>
        <div style={{ marginTop: "50px" }}>
          <img
            src={`.${base}/images/title.png`}
            className="blockWidth100"
            alt="타이틀"
          />
          <img
            src={`.${base}/images/coin.gif`}
            className="blockWidth100"
            alt="코인"
          />
          <div style={{ padding: "24px" }}>
            <img
              className="blockWidth100"
              src={`.${base}/images/info.png`}
              alt="logo"
            />
          </div>
        </div>
        <div className="overlay">
          <div className="downloadBannerWrapper">
            <div className="downloadBanner">
              <a href={deeplink}>
                <img src={`.${base}/images/downloadBox.png`} alt="logo" />
              </a>
            </div>
          </div>
        </div>
        {/* 링크복사 / 공유하기 */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            marginTop: "8px",
          }}
        >
          <div className="shareCopyWrap">
            <img
              src={`.${base}/images/copy.png`}
              alt="링크복사"
              style={{ width: "60px", borderRadius: "50%", cursor: "pointer" }}
              onClick={handleCopyToClipboard}
            />
            <span className="shareCopyText">링크복사</span>
          </div>
          <div className="shareCopyWrap">
            <img
              src={`.${base}/images/share.png`}
              alt="공유하기"
              style={{ width: "60px", borderRadius: "50%", cursor: "pointer" }}
              onClick={webShareUrl}
            />
            <span className="shareCopyText">공유하기</span>
          </div>
        </div>

        <div style={{ marginTop: "40px" }}>
          <img
            src={`.${base}/images/notice.png`}
            className="footerBox"
            alt="logo"
          />
        </div>
        <LandingFooter />
        <ToastContainer
          position="bottom-center"
          className="toastContainer"
          toastClassName="toast"
          bodyClassName="toastBody"
          newestOnTop={false}
          autoClose={2000}
          hideProgressBar={true}
          transition={Slide}
          closeButton={false}
        />
      </>
    );
  } else {
    return (
      <>
        <div className="desktop">
          <img
            src={`.${base}/images/desktop.png`}
            className="desktopImg"
            alt=""
          />
        </div>
        <LandingFooter />
      </>
    );
  }
}

export default App;
